import axios from "axios";

export const saveDocumentationRequest = (data, callback) => {
  axios({
    method: "post",
    url: `/api/documentation_requests`,
    data: data,
    headers: {
      "X-CSRF-TOKEN": window.Hupe8?.token || ""
    }
  })
    .then(response => {
      callback(response || { status: 500, data: {} }); // 🔥 Asegura que siempre se retorne un objeto válido
    })
    .catch(err => {
      callback(err.response || { status: 500, data: {} }); // 🔥 Previene undefined
    });
};

export const rememberRequest = (id, callback) => {
  axios({
    method: "post",
    url: `/api/documentation_requests/${id}/remember_request`,
    headers: {
      "X-CSRF-TOKEN": window.Hupe8?.token || ""
    }
  })
    .then(response => {
      callback(response || { status: 500, data: {} });
    })
    .catch(err => {
      callback(err.response || { status: 500, data: {} });
    });
};
